import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './rootReducer';
import iState from './initialState';

const initialState: any = iState;
const enhancers = [];
const middleware = [thunk];
const customWindow: ICustomWindow = window;

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = customWindow.__REDUX_DEVTOOLS_EXTENSION__;

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

const store: any = createStore(rootReducer, initialState, composedEnhancers);

export default store;

/* Redux dev tool is not default property of window, so we need to create a custom window object to let Typescript know that redux devtools can exist in window */

interface ICustomWindow extends Window {
  __REDUX_DEVTOOLS_EXTENSION__?: any;
}
